module.exports = __webpack_public_path__ + "static/media/blog1.5f17a72a.jpeg";